import { Arrow,
    Rect,
    Ellipse,
} from 'react-konva';
import DrawAction from "../enums/draw-action.js";
import EditableText from "./editable-text.jsx";

export default function ShapeRender({shapes, onShapeClick, drawAction, stageRef, setShapes, onShapeMove, currentShape, onTextChange}){

    function drawShape(shape){
        switch(shape.type){
            case DrawAction.ARROW:
            case DrawAction.ARROW_RED:
            case DrawAction.ARROW_BLUE:{
                return (
                    <Arrow
                        key={shape.id}
                        id={shape.id}
                        points={shape.points}
                        stroke={shape.color}
                        strokeWidth={shape.strokeSize}
                        onClick={onShapeClick}
                        draggable={drawAction === null || currentShape === shape.id}
                        onDragEnd={(e) => {
                            const { x, y } = e.target.position();
                            onShapeMove(shape.id, x, y);
                        }}
                    />
                );
            }
            case DrawAction.RECTANGLE:{
                return (
                    <Rect
                        x={shape.x}
                        y={shape.y}
                        height={shape.height}
                        width={shape.width}
                        stroke={shape.color}
                        key={shape.id}
                        id={shape.id}
                        strokeWidth={shape.strokeSize}
                        onClick={onShapeClick}
                        draggable={drawAction === null || currentShape === shape.id}
                        onDragEnd={(e) => {
                            const { x, y } = e.target.position();
                            onShapeMove(shape.id, x, y);
                        }}
                    />
                );
            }
            case DrawAction.CIRCLE:{
                return (
                    <Ellipse
                        key={shape.id}
                        id={shape.id}
                        x={shape.x}
                        y={shape.y}
                        radiusX={shape.radiusX}
                        radiusY={shape.radiusY}
                        stroke={shape.color}
                        strokeWidth={shape.strokeSize}
                        onClick={onShapeClick}
                        draggable={drawAction === null || currentShape === shape.id}
                        onDragEnd={(e) => {
                            const { x, y } = e.target.position();
                            onShapeMove(shape.id, x, y);
                        }}
                    />
                );
            }
            case DrawAction.TEXT: {
                return(
                    <EditableText
                        key={shape.id}
                        shape={shape}
                        drawAction={drawAction}
                        stageRef={stageRef}
                        setShapes={setShapes}
                        onClick={onShapeClick}
                        currentShape={currentShape}
                        onShapeMove={onShapeMove}
                        onTextChange={onTextChange}
                    />
                )
            }
            default:
                return null;
        }
    }

    return <>{shapes.map(drawShape)}</>
}